import { useNavigate } from "react-router";

const LoginErrorPage = () => {
  const navigate = useNavigate();

  const handleRetry = () => {
    sessionStorage.removeItem("loginDenied");
    navigate("/siteminder-login");
  };

  return (
    <div style={{ padding: "2rem", textAlign: "center", color: "#c0392b" }}>
      <h2>❌ Access Denied </h2>
      <p>
        Your access to the ODP portal was denied by SiteMinder. 
        This may happen if you are logged into a different DHS system, like MyPBC, HCSIS or COMPASS.
      </p>
      <p>
        Please <strong>log out from all other portals</strong> and try again, or try again in a private browser.
      </p>
      <button
        onClick={handleRetry}
        style={{
          marginTop: "1.5rem",
          padding: "0.6rem 1.2rem",
          fontSize: "1rem",
          backgroundColor: "#007bff",
          color: "white",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer"
        }}
      >
        🔄 Try Again
      </button>
    </div>
  );
};

export default LoginErrorPage;